import * as S from "../styles";
import * as yup from "yup";

/* eslint-disable @typescript-eslint/no-unused-vars */
import { Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import { useEffect, useState } from "react";

import AutoComplete from "../../../../components/hookForms/autoComplete";
import { Button } from "@mui/material";
import CheckBox from "../../../../components/hookForms/checkbox";
import CloseIcon from "@mui/icons-material/Close";
import DatePickerMui from "../../../../components/hookForms/datePicker";
import IGenericResult from "../../../../interfaces/IGenericResult";
import IconButton from "@mui/material/IconButton";
import RadioButton from "../../../../components/hookForms/radioButton";
import { format } from "date-fns";
import messages from "../../../../utils/messages";
import serviceCliente from "../../../../services/serviceCliente";
import serviceInstalacao from "../../../../services/serviceInstalacao";
import serviceRelatorio from "../../../../services/serviceRelatorio";
import serviceUsina from "../../../../services/serviceUsina";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

export interface IDialogProps {
    open: boolean;
    onClose?: any;
}

export default function Credito({ open, onClose }: IDialogProps) {
    const [usinaDataOptions, setUsinaDataOptions] = useState<IGenericResult[]>([]);
    const [clienteDataOptions, setClienteDataOptions] = useState<IGenericResult[]>([]);
    const [instalacaoDataOptions, setInstalacaoDataOptions] = useState<IGenericResult[]>([]);
    const [isDisable, setDisable] = useState(false);

    const validationSchema = yup.object().shape({
        usinas: yup.string().required(messages.requiredField),
        clientes: yup.string().required(messages.requiredField),
        instalacao: yup.string().required(messages.requiredField),
        dataInicio: yup.string().required(messages.requiredField),
        dataFim: yup.string().required(messages.requiredField),
    });

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            clientes: "",
            usinas: "",
            instalacao: "",
            dataInicio: "",
            dataFim: "",
        },
    });

    useEffect(() => {
        setUsinaData();
        setClienteData();
        setInstalacaoData();
    }, []);

    const setUsinaData = async () => {
        serviceUsina
            .getUsinas()
            .then((result) => {
                setUsinaDataOptions(result?.data);
            })
            .catch(() => {
                setUsinaDataOptions([]);
            });
    };

    const setClienteData = async () => {
        serviceCliente
            .getClientes()
            .then((result) => {
                setClienteDataOptions(result?.data);
            })
            .catch(() => {
                setClienteDataOptions([]);
            });
    };

    const setInstalacaoData = async () => {
        serviceInstalacao
            .getInstalacoes()
            .then((result) => {
                setInstalacaoDataOptions(result?.data);
            })
            .catch(() => {
                setInstalacaoDataOptions([]);
            });
    };

    const getRelatorio = async (filters) => {
        serviceRelatorio
            .getRelatorioCredito(filters)
            .then((result) => {
                if (result) {
                    toast.success(messages.reportSucess);
                }
            })
            .catch(() => {
                toast.error(messages.reportError);
            });
    };

    const onSubmit = (values: any) => {
        let dataInicio = new Date(values.dataInicio);
        let dataFim = new Date(values.dataFim);

        const treatedValues = {
            ...values,
            dataInicio: values?.dataInicio ? format(dataInicio, "MM/yyyy") : "",
            dataFim: values?.dataFim ? format(dataFim, "MM/yyyy") : "",
        };

        getRelatorio(treatedValues);
    };

    return (
        <div>
            <Dialog
                maxWidth="md"
                fullWidth
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        onClose();
                    }
                }}
                open={open}
            >
                <DialogTitle>
                    <S.Title>Gerar relatório: Crédito</S.Title>
                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            reset();
                            onClose();
                        }}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            // color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <DialogContent dividers>
                        <Grid item xs={12}>
                            {isDisable && (
                                <S.Loader>
                                    <img alt="Loading" src="/Loading.gif" width="40px" height="40px" />
                                </S.Loader>
                            )}
                        </Grid>

                        <S.Subtitles>Período de referência</S.Subtitles>
                        <Grid container spacing={2} display="flex" alignItems="center">
                            <Grid item xs={12} md={6}>
                                <DatePickerMui
                                    name="dataInicio"
                                    label="Início"
                                    view={["month", "year", "day"]}
                                    control={control}
                                    error={errors}
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <DatePickerMui
                                    name="dataFim"
                                    label="Fim"
                                    view={["month", "year", "day"]}
                                    control={control}
                                    error={errors}
                                />
                            </Grid>

                            <Grid item xs={12} md={12}>
                                <AutoComplete
                                    name="usinas"
                                    label="Usinas"
                                    options={usinaDataOptions}
                                    control={control}
                                    error={errors}
                                />
                            </Grid>

                            <Grid item xs={12} md={12}>
                                <AutoComplete
                                    name="clientes"
                                    label="Clientes"
                                    options={clienteDataOptions}
                                    control={control}
                                    error={errors}
                                />
                            </Grid>

                            <Grid item xs={12} md={12}>
                                <AutoComplete
                                    name="instalacao"
                                    label="Instalação"
                                    options={instalacaoDataOptions}
                                    control={control}
                                    error={errors}
                                />
                            </Grid>
                        </Grid>

                        <S.Spacing />
                        <Grid item xs={12} md={6}>
                            <CheckBox
                                name="redirecionar"
                                label="Redirecionar para a tela de relatório"
                                control={control}
                                error={errors}
                            />
                        </Grid>
                    </DialogContent>
                    <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                        <Button
                            style={{ width: "159px", height: "44px" }}
                            onClick={() => {
                                reset();
                                onClose();
                            }}
                            color="warning"
                            variant="contained"
                        >
                            Cancelar
                        </Button>
                        <Button
                            style={{ width: "159px", height: "44px" }}
                            onClick={() => {}}
                            type="submit"
                            variant="contained"
                        >
                            Gerar
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        </div>
    );
}
